import { routeBase } from "./routerConfig";

export const imgEjemploConstancia = routeBase + "/img/ejemplo_constancia.png";
